import {
  PAYMENT_LOAD_ATTEMPT,
  PAYMENT_LOAD_SUCCESS,
  PAYMENT_LOAD_FAILED,
  ///////////////////////
  PAYMENT_SAVE_ATTEMPT,
  PAYMENT_SAVE_SUCCESS,
  PAYMENT_SAVE_FAILED,
} from "../types/paymentTypes";

const INITIAL_STATE = {
  loading: false,
  saving: false,
  method: "none",
  transfer: false,
  gateway: false,
  loaded: false,
  error: "",
};

function payment(state = INITIAL_STATE, action) {
  switch (action.type) {
    case PAYMENT_LOAD_ATTEMPT:
      return { ...state, loading: true, error: "" };

    case PAYMENT_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        method: action.data.PaymentMethod || "none",
        transfer: Boolean(action.data.Transfer),
        gateway: Boolean(action.data.Gateway),
        error: "",
      };

    case PAYMENT_LOAD_FAILED:
      return { ...state, loading: false, error: action.error };

    case PAYMENT_SAVE_ATTEMPT:
      return { ...state, saving: true, error: "" };

    case PAYMENT_SAVE_SUCCESS:
      return {
        ...state,
        saving: false,
        loaded: true,
        method: action.data.PaymentMethod || "none",
        transfer: Boolean(action.data.Transfer),
        gateway: Boolean(action.data.Gateway),
        error: "",
      };

    case PAYMENT_SAVE_FAILED:
      return { ...state, saving: false, error: action.error };

    default:
      return state;
  }
}

export default payment;
